import ReactMarkdown from "react-markdown"
import { formatTime } from "../../hooks/formatTime";

export default function AssistantResponseCard({ rawText, timestamp, sources}) {
    const formattedTime = formatTime(timestamp);
  
    return (
    <div className="assistant-card">

        <div className="section">
            <ReactMarkdown>{rawText}</ReactMarkdown>
        </div>

        {formattedTime && (
            <div className="timestamp">{formattedTime}</div>
        )}

        {sources.length > 0 && (
            <details>
                <summary>Sources</summary>
                <ul>
                    {sources.map((src, idx) => (
                        <li key={idx}>
                            {src.url ? (
                                <a
                                href={src.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                    {src.title} | {src.site}
                                </a>
                            ) : (
                                <span>{src.title} | {src.site}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </details>
        )}
    </div>
  );
}